const formatEmailAddressForHashing = (email: string): string => {
  // Check if the email is from gmail.com or googlemail.com
  if (email.endsWith('@gmail.com') || email.endsWith('@googlemail.com')) {
    return email.toLowerCase().trim().replace(/\./g, '')
  }
  return email.trim()
}

export {
  formatEmailAddressForHashing,
}
